import HealthCardNew from "./HealthCardNew";
import HealthInsuranceNew from "./HealthInsuranceNew";

const Medical = ({
  personalInfo,
  healthInsuranceDetails,
  healthCardDetails,
  handleGetTableData,
  empPublicId,
  getEmployeeRegistrationData,
  currentEmployeeEditing = false,
}) => {
  return (
    <div>
      {/* Health Insurance Section */}
      <HealthInsuranceNew
        personalInfo={personalInfo}
        healthInsuranceDetails={healthInsuranceDetails}
        handleGetTableData={handleGetTableData}
        empPublicId={empPublicId}
        getEmployeeRegistrationData={getEmployeeRegistrationData}
        currentEmployeeEditing={currentEmployeeEditing}
      />

      <div className="h-1 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 rounded my-8" />

      {/* Health Card Section */}
      <HealthCardNew
        personalInfo={personalInfo}
        healthCardDetails={healthCardDetails}
        handleGetTableData={handleGetTableData}
        empPublicId={empPublicId}
        getEmployeeRegistrationData={getEmployeeRegistrationData}
        currentEmployeeEditing={currentEmployeeEditing}
      />
    </div>
  );
};

export default Medical;
